import * as snackbar from 'utils/snackbar'
import client from './api'

export const openFile = async uuid => {
  try {
    const { data: url } = await client.get(`/api/file/${uuid}/url`)
    window.open(url, '_blank', 'noopener')
  } catch (err) {
    snackbar.error(err?.message || 'The file could not be opened', { variant: 'error' })
  }
}

export const uploadFile = async file => {
  const formData = new FormData()
  formData.append('afile', file)
  const res = await fetch('/api/file', { method: 'POST', body: formData })

  if (!res.ok) {
    snackbar.error(res.statusText || 'The file could not be uploaded', { variant: 'error' })
    return null
  }
  return res.json()
}
